import { render } from "./FpTabIf.vue?vue&type=template&id=1a94aba4&lang=pug"
import script from "./FpTabIf.vue?vue&type=script&lang=js"
export * from "./FpTabIf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__